import { AppTemplate } from 'features/templates/types'
import { determineTagColor } from 'features/templates/utils'

type UseAppTemplateCollectionItemStateProps = {
    template: AppTemplate
}

export const useAppTemplateCollectionItemState = ({
    template,
}: UseAppTemplateCollectionItemStateProps) => {
    const tags =
        template.tags?.map((t) => {
            const color = determineTagColor(t)

            return {
                label: t,
                color,
            }
        }) ?? []

    return {
        tags,
    }
}
